<div id="head-nav" class="navbar navbar-default navbar-fixed-top">
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" data-toggle="collapse" data-target=".navbar-collapse" class="navbar-toggle">
        <span class="fas fa-cog"></span>
      </button>
      <a [routerLink]="['/']" class="navbar-brand">
        <img id="appLogo" [src]="logoUrl" alt="{{session.company.Name}}" class="img-responsive app-logo" />
      </a>
    </div>

    <!--Menu top-->
    <div class="navbar-collapse collapse">
      <ul class="nav navbar-nav" *ngIf="(session.menu | filterBy:['menuTop', true]).length > 0">
        <li class="dropdown" *ngFor="let lv1 of session.menu | filterBy:['menuTop', true]" data-id="{{lv1.id}}">
          <a [routerLink]="[lv1.route]" *ngIf="lv1.submenu.length === 0">
            <span>{{lv1.name}}</span>
          </a>
          <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle" aria-expanded="true"
            *ngIf="lv1.submenu.length > 0">
            <span>{{lv1.name}}</span>
            <b class='caret'></b>
          </a>
          <ul class="dropdown-menu" *ngIf="lv1.submenu.length > 0">
            <li class="{{lv2.submenu.length !== 0 ? 'dropdown-submenu' : ''}}"
              *ngFor="let lv2 of lv1.submenu | filterBy:['menuTop', true]">
              <a [routerLink]="[lv2.route]" *ngIf="lv2.submenu.length === 0">
                <span>{{lv2.name}}</span>
              </a>
              <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle" aria-expanded="true"
                *ngIf="lv2.submenu.length > 0">
                <span>{{lv2.name}}</span>
              </a>
              <ul class="dropdown-menu" *ngIf="lv2.submenu.length > 0">
                <li *ngFor="let lv3 of lv2.submenu | filterBy:['menuTop', true]">
                  <a [routerLink]="[lv3.route]">
                    <span>{{lv3.route}}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>

      <!-- Perfil -->
      <ul class="nav navbar-nav navbar-right user-nav">

        <li class="dropdown profile_menu" *ngIf="navBarPanels && navBarPanels.length > 0">
          <a href="#" data-toggle="dropdown" class="dropdown-toggle" (click)="openGraphics()"
            [title]="'GRAPHICS'|translate">
            <i class="fas fa-chart-line fa-lg no-padding margin-top-7"></i>
          </a>
        </li>

        <li class="dropdown profile_menu" *ngIf="session.company.ServiceProvider || !hideNonSPCompany">
          <a href="#" data-toggle="dropdown" class="dropdown-toggle" (click)="openCompanyInfo()">
            <i class="fas fa-building fa-lg"></i>
            <span>{{session.company.Name}}</span>
          </a>
        </li>

        <li class="dropdown profile_menu">
          <a href="#" data-toggle="dropdown" class="dropdown-toggle">
            <i class="far fa-user-circle fa-lg"></i>
            <span>{{session.user.Name}}</span>
            <b class="caret"></b>
          </a>

          <ul class="dropdown-menu">
            <li *ngIf="(session.company.ServiceProvider || !hideNonSPCompany) && !hideProfile">
              <a [routerLink]="['/profile']">{{'PROFILE' | translate}}</a>
            </li>
            <li class="divider" *ngIf="(session.company.ServiceProvider || !hideNonSPCompany) && !hideProfile">
            </li>

            <li title="{{'ABOUT_ID4' | translate}}" *ngIf="showAboutID4">
              <a (click)="openAboutID4Modal()">{{'ABOUT' | translate}}</a>
            </li>
            <li class="divider" *ngIf="showAboutID4">
            </li>

            <li>
              <a id="logout" href="javascript:void(0);" (click)="logout()">{{'BUTTON.LOGOUT' | translate}}</a>
            </li>
          </ul>
        </li>
      </ul>

      <!-- Mensagens -->
      <ul class="nav navbar-nav navbar-right not-nav">
        <li class="button dropdown" *ngIf="messages">
          <a [routerLink]="['/contacts/messages/geral']" class="dropdown-toggle" *ngIf="messages.length === 0">
            <i class="fas fa-envelope fa-lg"></i>
          </a>
          <a href="javascript:;" data-toggle="dropdown" class="dropdown-toggle" *ngIf="messages.length > 0">
            <i class="fas fa-envelope fa-lg"></i>
            <span class="bubble" *ngIf="messages.length > 0">{{messages.length}}</span>
          </a>
          <ul class="dropdown-menu">
            <li>
              <div class="nano nscroller">
                <div class="content">
                  <ul>
                    <li *ngFor="let message of messages; let i = index">
                      <a [routerLink]="['/contacts/messages/' + message[0].Value]">
                        <b>{{message[1].Value}}</b>
                        <span class="badge pull-right">{{message[2].Value}}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>

      <!-- Gráficos -->
      <!-- <ul class="nav navbar-nav navbar-right user-nav" *ngIf="navBarPanels && navBarPanels.length > 0">
        <li class="dropdown profile_menu">
          <a href="#" data-toggle="dropdown" class="dropdown-toggle" (click)="openGraphics()"
            [title]="'GRAPHICS'|translate">
            <i class="fas fa-chart-line fa-lg"></i>
            <span>&nbsp;</span>
          </a>
        </li>
      </ul> -->

    </div>
  </div>
</div>
<div id="cl-wrapper" class="fixed-menu">
  <!--Menu lateral-->
  <div class="cl-sidebar" *ngIf="(session.menu | filterBy:['menuLeft', true]).length > 0">
    <div class="cl-toggle">
      <i class="fas fa-bars"></i>
    </div>
    <div class="cl-navblock">
      <div class="menu-space">
        <div class="content">
          <ul class="cl-vnavigation" *ngIf="session.menu.length > 0">
            <li class="dropdown" *ngFor="let lv1 of session.menu | filterBy:['menuLeft', true]"
              [routerLinkActive]="['active']">

              <a [routerLink]="[lv1.route]" *ngIf="lv1.submenu.length === 0 && lv1.route !== '#'">
                <i class="{{lv1.icon}}" *ngIf="lv1.icon !== 'folderIcon'"></i>
                <i class="fas fa-list-alt" *ngIf="lv1.icon === 'folderIcon'"></i>
                <span>{{lv1.name}}</span>
              </a>

              <a href="javascript:void(0);" *ngIf="lv1.submenu.length === 0 && lv1.route === '#'">
                <i class="{{lv1.icon}}" *ngIf="lv1.icon !== 'folderIcon'"></i>
                <i class="fas fa-list-alt" *ngIf="lv1.icon === 'folderIcon'"></i>
                <span>{{lv1.name}}</span>
                <i class="fas fa-plus" style="float:right" *ngIf="createMenu" (click)="$event.stopPropagation();newMenu(lv1, true)"></i>
              </a>

              <a href="javascript:void(0);" *ngIf="lv1.submenu.length > 0">
                <i class="{{lv1.icon}}" *ngIf="lv1.icon !== 'folderIcon'"></i>
                <i class="fas fa-list-alt" *ngIf="lv1.icon === 'folderIcon'"></i>
                <span>{{lv1.name}}</span>
                <i class="fas fa-plus" style="float:right" *ngIf="createMenu" (click)="$event.stopPropagation();newMenu(lv1, true)"></i>
              </a>
              <ul class="sub-menu" *ngIf="lv1.submenu.length > 0">
                <!-- <li *ngFor="let lv2 of lv1.submenu | filterBy:['menuLeft', true]" [routerLinkActive]="['active']"> Assim nao inclui sub-rotas-->
                <li *ngFor="let lv2 of lv1.submenu | filterBy:['menuLeft', true]"
                  [class.active]="isLinkActive(lv2.route)">
                  <a [routerLink]="lv2.canRoute != false ? returnRoute(lv2.route) : []" [queryParams]="returnQueryParams(lv2.route)" (click)="lv2.canRoute = true">
                    <i class="{{lv2.icon}}" *ngIf="lv2.icon !== 'defaultLeafIcon'"></i>
                    <i class="fas fa-list-alt" *ngIf="lv2.icon === 'defaultLeafIcon'"></i>
                    <span class="ellipsis" [ngClass]="{ 'width-120': createMenu, 'width-170': !createMenu }">{{lv2.name}}</span>
                    <i class="fas fa-clone" *ngIf="createMenu && lv2.identifier != 'MenuOptions'" style="float:right" (click)="lv2.canRoute = false;newMenu(lv2)"></i>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="search-field collapse-button">
        <button id="sidebar-collapse" class="btn btn-default">
          <i class="fas fa-angle-left"></i>
        </button>
      </div>
    </div>
  </div>
  <div id="pcont" class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</div>

<!--Mete o fundo escuro ao abrir um Nifty Modal-->
<div class="md-overlay"></div>

<!--Para reintroduzir o login quando a sessão expirou-->
<button type="button" class="hide" id="needLogin" (click)="reAuthenticate()"></button>

<div class="hide">
  <!--Dockmodal criadas dinamicamente-->
  <div id="div-dockmodal-dynamics">
  </div>
</div>